import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { ClientDetailsTabItem } from '../../molecules/clientDetailsTabItem/ClientDetailsTabItem'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

export type ClientDetailsTabType = {
  displayName: string
  onTabPressed: () => void
  isActive: boolean
  disabled?: boolean
}

export type ClientDetailsTabNavigationProps = {
  backgroundColor?: string
  horizontalClientDetails?: boolean
  tabs: ClientDetailsTabType[]
}

const ClientDetailsTabNavigationContainer = styled.View<{
  theme: ThemeType
  backgroundColor?: string
  increasedGap?: boolean
}>(({ theme: { colors, spacing }, backgroundColor, increasedGap }) => ({
  backgroundColor: backgroundColor || colors.backgroundSection,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: increasedGap ? spacing['24px'] : spacing['16px'],
}))

export const ClientDetailsTabNavigation: FunctionComponent<ClientDetailsTabNavigationProps> = ({
  backgroundColor,
  horizontalClientDetails,
  tabs = [],
}) => {
  return (
    <ClientDetailsTabNavigationContainer
      testID={tID('ClientDetailsTabNavigation')}
      backgroundColor={backgroundColor}
      increasedGap={horizontalClientDetails}
    >
      {tabs.map((tab, tabIndex) => (
        <ClientDetailsTabItem
          key={`ClientDetailsTabItem-${tabIndex}`}
          testID={`ClientDetailsTabItem-${tab.displayName}`}
          tabDisplayName={tab.displayName}
          isActive={tab.isActive}
          onTabPressed={tab.onTabPressed}
          disabled={tab.disabled}
        />
      ))}
    </ClientDetailsTabNavigationContainer>
  )
}
